/**
 * Downloads a file from a URL without causing page navigation/flash.
 * Creates a temporary anchor element and programmatically clicks it.
 */
import { getSafeDownloadUrl } from "@/core/utils/url";

export const downloadFile = (
  url: string,
  filename: string = "payroll_download.xlsx",
) => {
  const safeUrl = getSafeDownloadUrl(url);
  if (!safeUrl) return;

  const link = document.createElement("a");
  link.href = safeUrl;
  link.style.display = "none";

  link.download = filename;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
